import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ASSET_CLASS_ORDER } from '@ddt-web/common';
import { ColorsConfig } from '@ddt-web/config';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ComponentData, TabUtil } from '@ddt-web/data-service';
import { NumberUtil } from '@ddt-web/generic-utils';
import { AggregatedPortfolioComposition, DisclosureComponent } from '@ddt-web/pdf-components';

import { HoldingsTableUtil } from '../helpers';

export class FamilyLatestHoldingsBodyComponent extends BusinessComponent {
	@InjectConfig(SharedConfigKey.ASSET_CLASS_COLORS) private readonly assetClassColors = ColorsConfig.ASSET_CLASS_COLORS;
	@InjectConfig(SharedConfigKey.ASSET_CLASS_ORDER) private readonly assetClassOrder = ASSET_CLASS_ORDER;
	public aggregatedPortfolioComposition = new AggregatedPortfolioComposition();

	constructor(name: string, public dataComponentId: string, public visible: boolean = true, public modelNames: string[] = [], public includePerformanceDcrSuffix: string = '') {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
		this.modelNames = ['', ...this.modelNames];
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		return componentData && componentData.success;
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisible(componentData)) {
			const formatter = (value: number): string => {
				return value ? NumberUtil.formatNumber(value, 1) : '-';
			};
			const transformedTabArray = this.aggregatedPortfolioComposition.getTransformedTab(componentData, 'weight', formatter, this.assetClassColors, this.assetClassOrder);
			const panels: AbstractRenderer<SVGGElement>[] = [];
			transformedTabArray.forEach(transformedTab => {
				if (TabUtil.isTabValid(transformedTab)) {
					panels.push(...HoldingsTableUtil.getTablePanels(transformedTab, contentSvc, this.modelNames));
				}
			});

			panels.push(
				new DisclosureComponent(
					`LATEST_HOLDINGS_DISCLAIMER_PDF${this.includePerformanceDcrSuffix}`,
					`LATEST_HOLDINGS_DISCLAIMER_PDF${this.includePerformanceDcrSuffix}`,
					{},
					{ marginTop: 4 }
				)
			);

			return panels;
		}
		return [];
	}
}
